module.exports = __webpack_public_path__ + "static/intro-dd62f92593005a881509f94bbdfafd43.mp4";